//This will display as an input element and Edit button, and when you click the button, a dialog will appear allowing you to create a custom report filter.
//To use this, put this in your HTML:
//  <advanced-report-filter #advancedFilter></advanced-report-filter>
//Then put this in your TS file:
//  @ViewChild('advancedFilter') advancedFilter: AdvancedReportFilterComponent;
//Then show it by calling this and passing the callback funtion into show():
//  this.advancedFilter.addDonor()
//
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { WebService, ApiResponse, Option, Designation, DesignationChoice, ReportFavorite } from '../web-service/web.service';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { DesignationChooserComponent } from '../designation-chooser/designation-chooser.component';
import { Formatter, ChromeDateFixer } from '../../shared/utilities/utilities';

@Component({
  selector: 'advanced-report-filter',
  templateUrl: './advanced-report-filter.component.html',
  styleUrls: ['./advanced-report-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancedReportFilterComponent implements OnInit {
  @ViewChild('modalEditFilter') modalEditFilter;
  msgBox: MessageBoxComponent;
  @ViewChild('desChooser') desChooser: DesignationChooserComponent;
  initedDesChooser: boolean = false;
  newFilterValue: string = "";
  conditionValue: string = "";
  conditionValue2: string = "";
  notCondition: boolean = false;
  showDateRange: boolean = true;
  fromDate: string = "";
  toDate: string = "";
  conditionNo: number = 1;
  conditionValueOptions: string[];
  conditionValueSelected: Option[];
  public allDonors: string[];
  public ledgerAccounts: string[];
  leadershipUser: boolean;
  callbackApply: Function;
  public desOptions: Designation[];
  gridFilter: ReportFavorite;
  oldValue: string;
  oldConditionNo: number;
  oldNotCondition: boolean;
  oldFromDate: string;
  oldToDate: string;
  justShowedDlgAboutFilterParametersHaveChanged: boolean = false;
  desChoices: DesignationChoice[] = [ new DesignationChoice() ]; //data source for the des chooser
  contributionTypes: string[] = ["Cash", "Check", "Qualified charitable distribution", "Donor-advised fund", "Credit card", "Bank transfer", "Marketable security", "Non-cash"];
  states: string[] = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District Of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "American Samoa", "Guam", "Northern Mariana Islands", "Puerto Rico", "Virgin Islands", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon"];
  filterSqlHash: any; //hash table of all the filterValues and their translated filterSqls. The filterValue gets translated to SQL on the server and passed back to us, and we keep a copy of it here and pass it back to the server so that it saves the server time (it doesn't have to translate it each time).

  constructor(private webService: WebService) {
  }

  ngOnInit() {
    ChromeDateFixer.initFixer();
    $("#modalEditFilter .modal-dialog").css("maxWidth", "1000px"); //By default the dialogs in this system are 500px wide, but we need our add/edit dialog to be wider.
  }

  //This is called when one of the conditions is selected from the dropdown. For each condition, there's a value that has to be selected or filled in by the user before the condition can be added to the filter text value. So this function is needed to set up certain things, like the value might be a list of something that changes for each condition.
  onConditionSelected() {
    this.conditionValueSelected = [];
    this.conditionValue = "";
    this.conditionValue2 = "";

    //The conditions greater than 10 have to do with donor names or states, so they don't need a date range.
    if (this.conditionNo > 10)
      this.showDateRange = false;
    else
      this.showDateRange = true;

    //conditionValueOptions is the data source for a multi-select dropdown that allows the user which values go with the condition.
    if (this.conditionNo == 8) //condition = contribution types
      this.conditionValueOptions = this.contributionTypes;
    else if (this.conditionNo == 10) {
      if (this.ledgerAccounts) //condition = ledger accounts; we have to get these from the server unless we've already gotten them before.
        this.conditionValueOptions = this.ledgerAccounts;
      else {
        this.webService.options_GetAllOptions(2, false).subscribe( //Passing a 2 to this will get the ledger accounts
          apiResponse => {
            if (ApiResponse.checkStatus(apiResponse)) {
              this.ledgerAccounts = apiResponse.optionList.map((item) => item.optionName);
              this.conditionValueOptions = this.ledgerAccounts;
            }
          }
        );
      }
    }
    if (this.conditionNo == 14) //condition = states that the donor lives in
      this.conditionValueOptions = this.states;
    else if (this.conditionNo == 11) { //condition = donors; we have to get these from the server unless we've already gotten them before.
      if (this.allDonors)
        this.conditionValueOptions = this.allDonors;
      else {
        this.webService.donors_GetAllDonorNames(false).subscribe(
          apiResponse => {
            if (ApiResponse.checkStatus(apiResponse)) {
              this.allDonors = apiResponse.optionList.map((item) => item.optionName);
              this.conditionValueOptions = this.allDonors;
            }
          }
        );
      }
    }
    else if (this.conditionNo == 9) { //condition = designations; we have to get these from the server unless we've already gotten them before.
      if (!this.desOptions) {
        this.webService.designations_GetAllDesignations(false, false, false).subscribe(
          apiResponse => {
            if (ApiResponse.checkStatus(apiResponse)) {
              this.desOptions = apiResponse.designationList;
              this.desChooser.initDesChooser(false, this.desOptions, this.desChoices, false, null, false, true, true);
              this.initedDesChooser = true;
            }
          }
        );
      }
      else if (!this.initedDesChooser) { //This is necessary because it's possible that this.desOptions was filled in from an outside source without us initing the desChooser yet.
        this.desChooser.initDesChooser(false, this.desOptions, this.desChoices, false, null, false, true, true);
        this.initedDesChooser = true;
      }
    }
  }

  //Call this to init this control when the page appears. callbackApply is the function to call back when the user clicks the Apply button on the dialog. leadershipUser is true if the current user is leadership, in which case we don't show certain filter conditions like donor names.
  initAdvancedFilter(msgBox: MessageBoxComponent, gridFilter: ReportFavorite, filterSqlHash: any, callbackApply: Function, leadershipUser: boolean) {
    this.msgBox = msgBox;
    this.gridFilter = gridFilter;
    this.filterSqlHash = filterSqlHash;
    this.callbackApply = callbackApply;
    this.leadershipUser = leadershipUser;
  }

  // Open the dialog to edit the filter
  editFilter() {
    this.modalEditFilter.show();
    this.newFilterValue = this.gridFilter.filterValue || "";
    // Get rid of validation errors
    $("#validationMsgFilter").css("display", "none");
    $("#fromDateField").removeClass("validation-error");
    $("#toDateField").removeClass("validation-error");
    $("*[data-not-blank]").each(function (index) {
      $(this).removeClass("validation-error");
    });
  }

  //Save filter text from the dialog textbox to the textbox on the parent page and close the dialog.
  finishEditFilter() {
    this.confirmFilterParametersHaveChanged("Apply", 
      () => {
        this.gridFilter.filterValue = this.newFilterValue;
        this.modalEditFilter.hide();
        if (this.callbackApply)
          this.callbackApply();
      }
    );
  }

  //Event handler when the user clicks the button to validate the filter text, which sends the text to the server to validate.
  validateFilter() {
    this.confirmFilterParametersHaveChanged("Validate",
      () => {
        //If the filter text is "" or if it already has a value in the filterSqlHash (which means the text has been validated before), we don't need to go to the server to validate.
        if (!this.newFilterValue || this.filterSqlHash[this.newFilterValue]) {
          //if justShowedDlgAboutFilterParametersHaveChanged is true, we have to delay for a moment because this is being shown immediately after the msgBox is closed inside of confirmFilterParametersHaveChanged(), and if there's no delay, this second one doesn't display properly.
          setTimeout(() => this.msgBox.show("Success", "The text of the advanced filter is valid.", false), this.justShowedDlgAboutFilterParametersHaveChanged ? 400 : 0);
        }
        else {
          this.webService.reports_ValidateAdvancedFilter(this.newFilterValue).subscribe(
            apiResponse => {
              if (ApiResponse.checkStatus(apiResponse)) {
                this.msgBox.show("Success", "The text of the advanced filter is valid.", false);
                this.filterSqlHash[this.newFilterValue] = apiResponse.message;
              }
            }
          );
        }
      }
    );
  }

  //This adds a condition to the filter value text, using the values from various fields on the dialog.
  //The addWithAnd param is used to add the condition with AND (true) or OR (false)
  addCondition(addWithAnd: boolean) {
    // Any field that cannot be blank will have the attribute "data-not-blank". If any of them are not filled in, we show the validation text and highlight the input by putting a class on them. Only save the data to the server and close the dialog if there are no validation errors.
    let blankError: boolean = false;

    $("*[data-not-blank]").each(function (index) {
      let inputID = $(this).attr('id');
      if (inputID && inputID.indexOf('subDes') != -1) //We ignore the three sub-des dropdowns inside of des-chooser because they are allowed to be blank
        return;

      //There are three different element types that we have to check for blank. If the element is type NG-SELECT, we have to check the text() method. Otherwise, we check the val() method.
      if ($(this).prop('nodeName').toUpperCase() == "NG-SELECT") {
        if (($(this).text() == '' || !$(this).text()) && $(this).is(":visible")) { // We only pay attention to this field if it's in a row that is visible. 
          blankError = true;
          $(this).addClass("validation-error");
        }
        else
          $(this).removeClass("validation-error");
      }
      else if (($(this).val() == '' || !$(this).val()) && $(this).is(":visible")) { // We only pay attention to this field if it's in a row that is visible. 
        blankError = true;
        $(this).addClass("validation-error");
      }
      else
        $(this).removeClass("validation-error");
    });

    if (blankError) {
      $("#validationErrorTdFilter").text("Fields marked with * cannot be blank");
      $("#validationMsgFilter").css("display", "");
      $("#fromDateField").removeClass("validation-error");
      $("#toDateField").removeClass("validation-error");
      return;
    }

    //If user has selected to include a date range, validate both date values.
    if (this.showDateRange) {
      if (!Formatter.validateDate(this.fromDate) || !Formatter.validateDate(this.toDate)) {
        $("#validationErrorTdFilter").text("The 'From' and 'To' fields must have valid dates");
        $("#validationMsgFilter").css("display", "");
        //We have to figure out if we put the validation error style on the toDate or fromDate field or both
        if (!Formatter.validateDate(this.fromDate))
          $("#fromDateField").addClass("validation-error");
        else
          $("#fromDateField").removeClass("validation-error");

        if (!Formatter.validateDate(this.toDate))
          $("#toDateField").addClass("validation-error");
        else
          $("#toDateField").removeClass("validation-error");
        return;
      }

      if (Date.parse(this.fromDate) > Date.parse(this.toDate)) {
        $("#validationErrorTdFilter").text("The 'From' date cannot be greater than the 'To' date");
        $("#validationMsgFilter").css("display", "");
        $("#fromDateField").addClass("validation-error");
        $("#toDateField").addClass("validation-error");
        return;
      }
    }
    //There are no validation errors
    $("#validationMsgFilter").css("display", "none");
    $("#fromDateField").removeClass("validation-error");
    $("#toDateField").removeClass("validation-error");

    const newValue = this.getValueForCondition();
    //replace spaces with underscores in the condition text
    let newCondition = $("#selectCondition option:selected").text().replace(/\s/g, "_");
    //If the condition has an X in it, replace the X with the value. Otherwise put the value at the end. Either way, surround the condition with parantheses.
    if (newCondition.indexOf("X") == -1)
      newCondition = `(${newCondition} ${newValue})`;
    else
      newCondition = `(${newCondition.replace("X", newValue)})`;

    if (this.notCondition) //If the NOT checkbox is checked, we add NOT to the beginning of the condition. 
      newCondition = newCondition.replace("(", "(NOT ");
    if (this.newFilterValue != '') //If this is not the first condition in the filter, add a newline and the word AND/OR
      newCondition = (addWithAnd ? '\r\nAND ' : '\r\nOR ') + newCondition;
    if (this.showDateRange) //If the date checkbox is checked, we add the date range to the end of the condition.
      newCondition = newCondition.replace(")", ` BETWEEN ${Formatter.toDate(this.fromDate)}, ${Formatter.toDate(this.toDate)}) `);
    //newFilterValue has the text of what's displayed in the big textbox on the right.
    this.newFilterValue += newCondition;
    //save the old values for all the controls that go into the condition
    this.oldValue = newValue;
    this.oldConditionNo = this.conditionNo;
    this.oldNotCondition = this.notCondition;
    this.oldFromDate = this.fromDate;
    this.oldToDate = this.toDate;
  }

  //returns what the value is that goes along with the condition depending on which condition is chosen. There are four different controls that might contain the value; only one of the four is visible at a time. There are two textboxes, one dropdown (multi-select), and a des-chooser.
  getValueForCondition() {
    if (this.conditionNo < 8) //numeric textbox
      return this.conditionValue;
    else if (this.conditionNo == 8 || this.conditionNo == 10 || this.conditionNo == 11 || this.conditionNo == 14) //multi-select dropdown; we get the values of all the selected options and join them into one string.
      return this.conditionValueSelected.join('^ ');
    else if (this.conditionNo == 9) //des-chooser: we get the values from the four dropdowns using jquery; we get the values of all the selected options and join them into one string
      return `${$("#desDropdown0 option:selected").text().trim()}^ ${$("#subDes1Dropdown0 option:selected").text().trim()}^ ${$("#subDes2Dropdown0 option:selected").text().trim()}^ ${$("#subDes3Dropdown0 option:selected").text().trim()}`;
    else //textbox for donor name
      return this.conditionValue2;
  }

  //If the user hits Enter while in the textbox, we programmatically click the Apply button, which will query to the server.
  enterKeyPressHandler() {
    if (this.callbackApply)
      this.callbackApply();
  }

  //This function is to check fo the case where the user has changed some of the condition parameters on the left but forgotten to click the "add condition" button before clicking Validate or Apply. So we check to see if any of the parameters have changed since the last condition was added. If nothing has changed, great, we go ahead and do the validate or apply action by calling the callback function. If something has changed, then we show a confirmation dialog asking if they want to continue or if they meant to click "Add condition" first. 
  confirmFilterParametersHaveChanged(actionName: string, callbackAction: Function) {
    const newValue = this.getValueForCondition();
    if (this.oldValue == newValue && this.oldConditionNo == this.conditionNo && this.oldNotCondition == this.notCondition && this.oldFromDate == this.fromDate && this.oldToDate == this.toDate) {
      this.justShowedDlgAboutFilterParametersHaveChanged = false;
      callbackAction();
    }
    else {
      this.justShowedDlgAboutFilterParametersHaveChanged = true;
      this.msgBox.show("Confirm", `You have changed condition parameters without adding the condition to the advanced filter text on the right. Are you sure you want to ${actionName.toLowerCase()} the filter? If you meant to add the condition, click "No" and then "Add condition" and then "${actionName}" again.`,
        true, callbackAction);
    }
  }
}
